<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/comUpwardStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN6111",
          "parkName": "测试停车场",
          "parkingCode": "19000029902389",
          "carNo": "粤E12345",
          "enterTime": "20191017010101",
          "parkingFee": 2.01,
          "shouldPayValue": 1.99
        },
        responseCode: {
          "data": {
            "thirdBillCode": "thirdbill0001",
            "payOrigin": "3",
            "payOriginRemark": "微信",
            "paymentMode": "12",
            "paymentModeRemark": "第三方余额"
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "智慧停车开放平台主动请求，通知第三方接入系统对预存款车辆进行扣费，第三方务必在10s内响应，超时我方将自动断开连接",
          urlPattern: this.commonUrls.third + "reducePrestore",
          precondition: {
            preData: "接入接口",
            link:  "下发预存款",
            url: "setPrestore",
            endData: "，用于进场时下发预存款"
          },
          fitSystem: "VEMS传统停车场，云停车场，第三方停车场",
          pattern: "第三方接入系统提供接口, 智慧停车开放平台主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号'},
              {info1: 'parkName', info2: '否', info3: 'String', info4: '停车场名称'},
              {info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号'},
              {info1: 'carNo', info2: '是', info3: 'String', info4: '车牌号'},
              {info1: 'enterTime', info2: '是', info3: 'String', info4: 'yyyyMMddHHmmss进场时间'},
              {info1: 'parkingFee', info2: '是', info3: 'Decimal', info4: '流水此次停车总费用，单位：元'},
              {info1: 'shouldPayValue', info2: '是', info3: 'Decimal', info4: '需缴费用，单位：元'},
              {info1: 'channelId', info2: '否', info3: 'Long', info4: '离场通道ID'},
              {info1: 'channelCode', info2: '否', info3: 'String', info4: '离场通道自定义编码'},
              {info1: 'otherAttr', info2: '否', info3: 'JSONObject', info4: '额外信息，缴费时传回，用于扩充其他需要的信息。现有一属性，券列表'}
            ]
          },
            {
              titleName: 'otherAttr部分参数说明',
              tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
                tableHead: '类型',
                tdName: 'info3'
              }, {tableHead: '说明', tdName: 'info4'}],
              td: [
                {info1: 'timeoutLength', info2: '否', info3: 'int', info4: '剩余免费时长，单位秒;VEMS2.13级以上版本支持'},
                {info1: 'traderCouponList', info2: '否', info3: 'JsonArray', info4: '电子券优惠'},
              ]
            },
            {
              titleName: 'traderCouponList：对应查询时的电子券优惠响应',
              tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
                tableHead: '类型',
                tdName: 'info3'
              }, {tableHead: '说明', tdName: 'info4'}],
              td: [
                {info1: 'isValid', info2: '是', info3: 'Boolean', info4: '是否可用'},
                {info1: 'traderCouponGrantSn', info2: '否', info3: 'JsonArray', info4: '电子券优惠'},
                {info1: 'traderCouponValue', info2: '否', info3: 'Decimal', info4: '券优惠金额。字段类型视券类型确定'},
              ]
            }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'},
              {tableHead: '类型', tdName: 'info3'}, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'thirdBillCode', info2: '是', info3: 'String', info4: '第三方系统订单号，每条账单唯一，用于重复同步时判断重复和对账（不超过30位）'},
              {info1: 'payOrigin', info2: '是', info3: 'int', info4: '支付来源'},
              {info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注(字段长度不得超过20位)'},
              {info1: 'paymentMode', info2: '是', info3: 'int', info4: '支付方式'},
              {info1: 'paymentModeRemark', info2: '否', info3: 'String', info4: '支付方式备注(字段长度不得超过20位)'},
              {info1: 'couponList', info2: '否', info3: 'JSONArray', info4: '缴费优惠金额'}
            ]
          },
            {
              titleName: 'couponList：第三方优惠',
              tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
                tableHead: '类型',
                tdName: 'info3'
              }, {tableHead: '说明', tdName: 'info4'}],
              td: [
                {info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称'},
                {info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '抵扣金额'},
                {info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠编码（长度不超过32位）'}
              ]
            }]
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/trade/reducePrestore.vue